import Vue from 'vue'
import App from './App.vue'
import {store} from '../basic/tools/store.js'
import '../basic';
import {router} from './mainextend'
new Vue({
  router,
  store,
  render: function (h) {
    return h(App)
  }
}).$mount('#app')
